import React, { useEffect, useState } from "react";
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';
import useAuth from '../../hooks/useAuth';
import MonthlyGoalTab from "./tabs/monthly-goal";
import YearEndBonusTab from "./tabs/year-end-bonus";
import BestImprovementAwardProgramTab from "./tabs/best-improvement-award-program";
import BonusStructure2026Tab from "./tabs/bonus-structure-2026";
import './year-end.css';



const BonusPage = () => {
    const { user, updateCustomers } = useAuth();
    const [activeTab, setActiveTab] = useState('monthly-sales-goal');
    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || 2026 Year End Bonus',
            metaDescription: '',
        });
    }, [user]);
  
    return (
        <main className="techtop-middle-div">
            <section className="techtop-bonus-tracker-section pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="techtop-default-title2">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h1 className="m-0 dark-color1">2026 Year-End Bonus</h1>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <h1 className="m-0 dark-color1">{user.name}</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-1" id="techtop-bonus-tracker-tabs">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'monthly-sales-goal' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('monthly-sales-goal')}
                                            >
                                                Monthly Sales Goal
                                            </button>
                                        </li>

                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'year-end-bonus' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('year-end-bonus')}
                                            >
                                                Year-End Bonus
                                            </button>
                                        </li>

                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === 'best-improvement-award-program' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('best-improvement-award-program')}
                                            >
                                                Best Improvement Award Program
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === '2026-bonus-structure' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('2026-bonus-structure')}
                                            >
                                                2026 Bonus Structure
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content mt-3">
                                        <MonthlyGoalTab
                                            key={activeTab === 'monthly-sales-goal' ? 'monthly-sales-goal' : ''}
                                            active={activeTab === 'monthly-sales-goal'}
                                        />
                                        <YearEndBonusTab
                                            key={activeTab === 'year-end-bonus' ? 'year-end-bonus' : ''}
                                            active={activeTab === 'year-end-bonus'}
                                        />
                                        <BestImprovementAwardProgramTab
                                            key={activeTab === 'best-improvement-award-program' ? 'best-improvement-award-program' : ''}
                                            active={activeTab === 'best-improvement-award-program'}
                                        />
                                        <BonusStructure2026Tab
                                            key={activeTab === '2026-bonus-structure' ? '2026-bonus-structure' : ''}
                                            active={activeTab === '2026-bonus-structure'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default BonusPage;